"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GUIController = void 0;
const gs = require("@ivanlog/gs");
//import * as modalCom from "@ivanlog/gs-com-modal_dialogs";
const App_1 = require("../App");
const AppControllerBase_1 = require("./AppControllerBase");
const Helper_1 = require("../Helper");
const tmpls_1 = require("../com/tmpls");
class GUIController extends AppControllerBase_1.AppControllerBase {
    constructor(app) {
        super(app);
        this.layouts = new Map();
        this._onChangePageToken = new gs.EventGSToken();
        this.onChangePage = new gs.EventGS(this._onChangePageToken);
        this._lockCounter = 0;
        this._body = gs.q('body').first;
    }
    initialize() {
    }
    setLayout(layout) {
        const layoutCmp = this.layouts.get(layout);
        if (this._currentLayout == layoutCmp)
            return;
        if (this._currentLayout != null)
            this._currentLayout.cut();
        if (layoutCmp) {
            this._body.prepend(layoutCmp);
            this._pageContainer = layoutCmp.ctrls.pageContainer;
            this._currentLayout = layoutCmp;
        }
    }
    showPage(page) {
        if (this._page)
            this._page.cut();
        this._page = page;
        this._pageContainer.append(page);
        // const newTheme = page.getData('theme');
        // if (newTheme)
        // {
        //     const themeEnum = DesignThemeEnum[newTheme];
        //     if (themeEnum) this.setTheme(themeEnum);     
        // }           
        this._onChangePageToken.invoke();
        page.show();
    }
    hidePage() {
        if (!this._page)
            return;
        this._page.cut();
        this._page = undefined;
    }
    lock() {
        if (this._lockCounter === 0)
            this._body.disable();
        this._lockCounter++;
    }
    unlock() {
        this._lockCounter--;
        if (this._lockCounter === 0)
            this._body.enable();
    }
    lockAction(action) {
        return __awaiter(this, void 0, void 0, function* () {
            this.lock();
            const r = yield action;
            this.unlock();
            return r;
        });
    }
    showBreadcrums() {
    }
    showPopAuth(callback = undefined) {
    }
    showPopMessage(message) {
        const dialog = new tmpls_1.CmpPopYesNoCancelDialog();
        dialog.ctrls.lText.text = message;
        this._body.append(dialog);
    }
    showOnlyOkMessage(message) {
        const dialog = new tmpls_1.CmpPopYesNoCancelDialog();
        dialog.ctrls.btnClose.hide();
        dialog.ctrls.lHeader.hide();
        dialog.ctrls.btnNo.hide();
        dialog.ctrls.btnCancel.hide();
        dialog.ctrls.lText.text = message;
        this._body.append(dialog);
        return new Promise((resolve) => {
            dialog.ctrls.btnYes.onclick = () => { dialog.cut(); resolve(true); };
        });
    }
    // public setTheme(theme:DesignThemeEnum) {
    //     for (const i in this._body.el.classList) {
    //         const c = this._body.el.classList[i];
    //         if (!c) continue;
    //         if (c.indexOf)
    //             if (c.indexOf('theme') === 0) this._body.removeClass(c);
    //     }
    //     if (theme) this._body.addClass(`theme_${theme}`);
    // }
    showGalleryAsync(files, index = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = [];
            const awaits = [];
            let i = 0;
            for (const file of files) {
                let imgData = { src: App_1.App.FILES_PATH + file, w: 0, h: 0 };
                data[i] = imgData;
                const img = new Image();
                img.onload = function () {
                    awaits.push(new Promise((resolve) => {
                        imgData.w = img.width;
                        imgData.h = img.height;
                        resolve(true);
                    }));
                };
                img.src = imgData.src;
                i++;
            }
            yield Promise.all(awaits);
            //Даем время на переключение контекста после загрузки (иначе PhotoSwipe глючит)
            yield Helper_1.Helper.awaitTime(100);
            const gallery = new globalThis.PhotoSwipe(document.querySelector('div.pswp'), globalThis.PhotoSwipeUI_Default, data, { index, history: false });
            gallery.init();
        });
    }
}
exports.GUIController = GUIController;
//# sourceMappingURL=GUIController.js.map